import { ArticulosEcommerce } from '../public-api';
import { ArticulosGeneral } from './articulos-general.interface';
import { PromoItemEcommerce } from '../interfaces/promo-item.interface';

export abstract class PromocionesEccomerce extends ArticulosGeneral {
  constructor(
    private abv: string,
    private cantidad1: number,
    private cantidad2: number,
    private desde: string,
    private hasta: string,
    private idpromocion: number,
    private imagen: string,
    private foto: string,
    protected monto: number,
    private nombre: string,
    private orden: number,
    protected porcentaje: number,
    private regla1: string,
    private regla2: string,
    private sucursal: number,
    private lunes: string,
    private martes: string,
    private miercoles: string,
    private jueves: string,
    private viernes: string,
    private domingo: string,
    private sabado: string,
    private tipo: string,
    private idPromo: string,
    marca: number,
    codigo: number,
    protected descargo: boolean,
    protected articulo1?: ArticulosEcommerce,
    protected articulo2?: ArticulosEcommerce,
    protected items?: PromoItemEcommerce[],
    private imagenMobile?: string
  ) {
    super(marca, codigo, 0);
    this.counter = 0;
    this.cantidadInicial = 0;
    this.descontado = 0;
    this.articulosItems = [];
  }

  /**
   * Renglones crudos de ItemPromocionWeb (tipo N/M). Vacío en promos tipo P/C/O.
   */
  getItemsData(): PromoItemEcommerce[] {
    return this.items || [];
  }

  /**
   * Artículos ya resueltos contra el catálogo, en el mismo orden que getItemsData().
   * Se completa desde asignarPromociones() en ecommerce-generico.service.ts.
   */
  getArticulosItems(): ArticulosEcommerce[] {
    return this.articulosItems;
  }

  agregarArticuloItem(articulo: ArticulosEcommerce) {
    this.articulosItems.push(articulo);
  }

  resetArticulosItems() {
    this.articulosItems = [];
  }

  protected articulosItems: ArticulosEcommerce[];

  agregarBultos(numero: number) { }
  
  getCantidadBultos() {
    return 0;
  }
  
  setCantidadBultos(cantidadBultos: number) { }

  getUnidadesPorBulto() {
    return 1;
  }

  setCantidadBultosInicial(v: number) { }

  getCantidadBultosInicial() {
    return 0;
  }

  resetArticulos() {
    const articulo = this.articuloenPromo();
    // Con promos de Categoria, items[] puede llegar vacío (o su primer
    // artículo puede no estar en el catálogo cargado), y ahí articulo1/2
    // nunca se setean. Antes esto no pasaba porque el modelo de artículo
    // fijo global siempre tenía uno resuelto.
    if (articulo) {
      articulo.promoCiones = [];
      articulo.resetPrecios();
    }
    this.counter = 0;
  }

  getFotoImagen() {
    return this.imagen;
  }
  getFoto() {
    return this.foto;
  }

  /**
   * Imagen recortada 9:16 para mobile (campo imagenMobile en PromocionesWeb).
   * Puede venir vacía si la promo todavía no tiene imagen mobile cargada;
   * en ese caso hay que usar getFotoImagen()/getFoto() con object-fit:
   * contain para no deformar la imagen normal en pantallas verticales.
   */
  getImagenMobile() {
    return this.imagenMobile || '';
  }

  getMontoPromocion() {
    return this.monto || 0;
}

  getMarcaA2() {
    if (this.articulo2 == undefined) {
      return -1;
    }
    return this.articulo2.getMarca() || -1;
  }

  getCodigoA2() {
    if (this.articulo2 == undefined) {
      return -1;
    }
    return this.articulo2.getCodigo() || -1;
  }

  getMarcaA1() {
    if (this.articulo1 == undefined) {
      return -1;
    }
    return this.articulo1.getMarca() || -1;
  }

  getCodigoA1() {
    if (this.articulo1 == undefined) {
      return -1;
    }
    return this.articulo1.getCodigo() || -1;
  }

  getCantidadInicial() {
    return this.cantidadInicial;
  }

  protected esDoblePromo(): boolean {
    let esdoble: boolean = true;

    if (this.articulo1 == undefined) {
      esdoble = false;
    }
    if (this.articulo2 == undefined) {
      esdoble = false;
    }
    return esdoble;
  }

  articuloenPromo(): ArticulosEcommerce | null {
    if (this.articulo1) return this.articulo1;
    if (this.articulo2) return this.articulo2;
    return null; 
  }

  cantidadenPromo(): number {
    if (this.articulo1 != undefined) {
      return this.getCantidad1();
    }
    if (this.articulo2 != undefined) {
      return this.getCantidad2();
    }
  }

  sumarCantPromo(arg0: number) {
    throw new Error('Method not implemented.');
  }

  forzarAddPromo(v: number) {
    throw new Error('Method not implemented.');
  }

  setCantidadInicial(v: number) {
    throw new Error('Method not implemented.');
  }

  getPromos() {
    return [];
  }

  getDestacado(): number {
    return 0;
  }

  getInformacionAdicional(): string {
    return '';
  }

  getDescripCion() {
    return this.nombre || '----------';
  }

  getNombrePromocion(){
    return this.nombre
  }

  getOrden() {
    return this.orden;
  }

  getTipoPromo() {
    return this.abv;
  }

  getAbreviaturaPromocion(){
    return this.abv
  }

  getTipo() {
    return this.tipo;
  }

  getregla1() {
    return this.regla1 || '';
  }

  getregla2() {
    return this.regla2 || '';
  }

  getID(): string {
    return this.idPromo;
  }

  getArticulo1(){
    return this.articulo1
  }

  /**
   * PromocionesWeb ya no tiene cantidad1/cantidad2 propios (se movieron a
   * ItemPromocionWeb), por eso se prioriza el primer item resuelto y se cae
   * al valor del constructor solo como resguardo si no hay items.
   */
  getCantidad1(){
    const item = this.getItemsData()[0];
    return item ? item.cantidad1 : this.cantidad1;
  }

  getCantidad2(){
    const item = this.getItemsData()[0];
    return item ? item.cantidad2 : this.cantidad2;
  }

  setArticulo2(k: ArticulosEcommerce) {
    this.articulo2 = k;
  }

  setArticulo1(k: ArticulosEcommerce) {
    this.articulo1 = k;
  }

  getMarcaPromocion(){
    return this.marca
  }

  getCodigoPromocion(){
    return this.codigo
  }

  getNombreMarca() {
    let presentacion = '';
    if (this.esDoblePromo()) {
      presentacion += this.articulo1.getNombreMarca();
      presentacion += '/';
      presentacion += this.articulo2.getNombreMarca();
    } else {
      presentacion += this.articuloenPromo().getNombreMarca();
    }
    return presentacion;
  }
  getNombreRubro() {
    return "Rubro Promoción";
  }
  getNombreFamilia() {
    return "Familia Promoción";
  }

  getPorcentaje(){
    return this.porcentaje || 0;
  }

  getPromocionValida(){
   
    let articuloRegla1Seteado = true;
    let articuloRegla2Seteado = true;
    if(this.regla1.length !== 0){
      articuloRegla1Seteado = this.articulo1 !== undefined
    }
    if(this.regla2.length !== 0){
      articuloRegla2Seteado = this.articulo2 !== undefined
    }
    return articuloRegla1Seteado && articuloRegla2Seteado && (this.getFoto() || this.getFotoImagen())
  }

  setFoto(arg0: string) {
    this.imagen = arg0;
  }

  abstract getDescontadoTotal(): number;
  abstract getDescontado(): number;
  abstract getPrecio();
  abstract getPrecioSinImp();
  abstract getPrecioNormal();
  abstract getPrecioAmostrar();
  abstract getPrecioOferta(): number;
  abstract getPresentacion();
  abstract preconPromo(
    precio: number,
    cantidad: number,
    modificacionActual: number
  );
  abstract agregarCantidad(numero: number);
  abstract setCantidad(arg0: number);
  abstract getCantidad();
  abstract hacerCalculos();
  abstract aplicarPromocion(precio : number)

  counter: number;
  promocionValida : boolean;

  protected descontado: number;
  private cantidadInicial: number;
  montoTotalADescontar: number = 0;
}
